import { getUiLocale } from './locale';
import { tx } from './pack';

const UNIT_KEY: Record<string, string> = {
  MINUTE: 'flow.editor.unit.minute',
  HOUR: 'flow.editor.unit.hour',
  DAY: 'flow.editor.unit.day',
};

/** 同名 en 在不同枚举里中文不同，按现网 show 拆 key。 */
const EN_SHOW_KEY: Record<string, Record<string, string>> = {
  ABSOLUTE: {
    绝对时间: 'flow.config.ABSOLUTE.absoluteTime',
    自定义时间: 'flow.config.ABSOLUTE.customTime',
  },
  CUSTOM: {
    自定义时间: 'flow.config.ABSOLUTE.customTime',
  },
  AFTER: {
    日期之后: 'flow.config.AFTER.date',
    '在...后': 'flow.config.AFTER.relative',
  },
};

function looksChinese(text: string) {
  return /[\u4e00-\u9fff]/.test(text);
}

/** 「浏览商品/Viewed Product」在英/越界面取斜线后的英文。 */
function bilingualTail(show: string) {
  const idx = show.lastIndexOf('/');
  if (idx <= 0) {
    return '';
  }
  const left = show.slice(0, idx).trim();
  const right = show.slice(idx + 1).trim();
  if (right && looksChinese(left) && !looksChinese(right)) {
    return right;
  }
  return '';
}

function packKey(en: string, show: string) {
  const byShow = EN_SHOW_KEY[en]?.[show];
  if (byShow) {
    return byShow;
  }
  return UNIT_KEY[en] || `flow.config.${en}`;
}

/**
 * getFlowConfig 的 show/en 展示。
 * 中文锁现网 show；英/越先查 flow.config.{en}，没有则拆「中文/English」。
 */
export function flowConfigLabel(item?: { en?: string; show?: string } | null) {
  if (!item) {
    return '';
  }
  const show = item.show || item.en || '';
  if (getUiLocale() === 'zh-CN') {
    return show;
  }
  const en = item.en || '';
  if (en) {
    const packed = tx(null, packKey(en, show), '');
    if (packed) {
      return packed;
    }
  }
  return bilingualTail(show) || show;
}

export function flowTypeOptionLabel(item?: { en?: string; show?: string } | null) {
  if (!item) {
    return '';
  }
  if (item.en === 'TRIGGER_A') {
    return tx(null, 'flow.editor.trigger.type.event', '用户触发特定事件');
  }
  if (item.en === 'TRIGGER_A_FENQUN') {
    return tx(null, 'flow.editor.trigger.type.segment', '用户进入特定用户群');
  }
  return flowConfigLabel(item);
}
